<app-impact-toolbar
  [title]="'DEPENDENCY_TREE.GRID_VIEW_TITLE'"
  [multiple]="!queryParams?.dependencyTree"
  [node]="node"
  [showTopDivider]="!isFree()">
  <ng-container class="top">
    <q9-icon-button
      *ngIf="!isFree()"
      icon="export-large-dataset"
      [matMenuTriggerFor]="toolbarMenu"></q9-icon-button>

    <mat-menu #toolbarMenu class="q9-menu" [overlapTrigger]="false">
      <button mat-menu-item (click)="downloadGridViewCsv()" q9Track="DEPENDENCY_GRID.DOWNLOAD_CSV">
        {{ 'REPORTS.DEPENDENCY_GRID_CSV' | translate }}
      </button>
    </mat-menu>
  </ng-container>

  <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="second" *ngIf="queryParams?.dependencyTree">
    <button mat-tab-link q9Track="DEPENDENCY_TREE.TREE_VIEW" (click)="backToTreeView()">
      {{ 'DEPENDENCY_TREE.TREE_VIEW' | translate }}
    </button>
    <button mat-tab-link [active]="true" q9Track="DEPENDENCY_TREE.GRID_VIEW">
      {{ 'DEPENDENCY_TREE.GRID_VIEW_TITLE' | translate }}
    </button>
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>

  <ng-container reloadTreeButton>
    <q9-primary-button [matMenuTriggerFor]="columnCustomizationMenu">
      {{ 'DEPENDENCY_TREE.CUSTOMIZE_GRID' | translate }}
    </q9-primary-button>
    <q9-icon-button
      icon="refresh"
      (click)="grid.loadEntities()"
      tooltipPosition="below"
      [tooltip]=" 'TOOLTIPS.RELOAD' | translate "></q9-icon-button>

    <mat-divider vertical="true"></mat-divider>
  </ng-container>
  <ng-container resetFiltersBtn>
    <q9-icon-button
      icon="filter-reset"
      (click)="grid.resetFilters()"
      [tooltip]=" 'DEPENDENCY_TREE.GRID_RESET_FILTERS' | translate "
      [disabled]="!filters().length"></q9-icon-button>
  </ng-container>
</app-impact-toolbar>

<div class="content">
  <q9-blur-wrapper
    [class.full-height]="true"
    [blur]="isFree()"
    [title]="paywallTitle()"
    [text]="'DEPENDENCY_TREE.PAYWALL_GRID_SUBTITLE'">
    <q9-grid
      #grid
      [columns]="gridColumns"
      [sortable]="false"
      [selectBy]="idField"
      [enableMultiSelect]="true"
      [displayHorizontalContextMenu]="true"
      [menuItems]="menuItems"></q9-grid>
  </q9-blur-wrapper>

  <ng-container *ngIf="!isFree() && (selectedNode$ | async) as node">
    <q9-org-node-sidebar
      [opened]="showSidebar$ | async"
      [disableClose]="false"
      [orgInfo]="orgInfo$ | async"
      [node]="node"
      [refModel]="refModelData$ | async"
      *ngIf="(refModelData$ | async).external"></q9-org-node-sidebar>

    <q9rme-internal-node-sidebar
      [disableClose]="false"
      [orgInfo]="orgInfo$ | async"
      [node]="node"
      [refModel]="refModelData$ | async"
      *ngIf="!(refModelData$ | async).external"></q9rme-internal-node-sidebar>
  </ng-container>
</div>

<mat-menu #columnCustomizationMenu [overlapTrigger]="false">
  <section (click)="$event.stopPropagation()" class="column-customization-menu">
    <mat-panel-title>
      <mat-checkbox
        [checked]="ensureAttributeParity"
        (change)="toggleAttributeParity($event.checked)"
        (click)="$event.stopPropagation()">
        {{ 'DEPENDENCY_TREE.ENSURE_ATTRIBUTE_PARITY' | translate }}
      </mat-checkbox>
    </mat-panel-title>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'SIDEBAR.GENERAL' | translate }}</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="checkbox-wrapper">
        <mat-checkbox
          *ngFor="let column of getGeneralColumns()"
          [checked]="isColumnVisible(column.field)"
          (change)="toggleColumn(column.field, $event.checked)">
          {{ column.title }}
        </mat-checkbox>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'DEPENDENCY_TREE.CUSTOMIZE_SOURCE' | translate }}</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="checkbox-wrapper">
        <mat-checkbox
          *ngFor="let column of getSourceColumns()"
          [checked]="isColumnVisible(column.field)"
          (change)="toggleColumn(column.field, $event.checked)">
          {{ column.title }}
        </mat-checkbox>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'DEPENDENCY_TREE.CUSTOMIZE_DEPENDENT' | translate }}</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="checkbox-wrapper">
        <mat-checkbox
          *ngFor="let column of getDependentColumns()"
          [checked]="isColumnVisible(column.field)"
          (change)="toggleColumn(column.field, $event.checked)">
          {{ column.title }}
        </mat-checkbox>
      </div>
    </mat-expansion-panel>
  </section>
</mat-menu>
